// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const productPriceStyle = css`
  .original-price {
    .pre,
    .post {
      line-height: 2.2;
      color: ${(props) => props.theme.colorPalette.gray[600]};
    }
    text-decoration: line-through;
  }
  .badge {
    line-height: 2;
    margin-left: 8px;
  }
  .list-badge-container {
    display: flex;
    align-items: center;
    ${(props) => (props.isNewPDPEnabled ? 'padding-left: 16px;' : '')}
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) => (props.isNewPDPEnabled ? 'padding-left: 8px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.isNewPDPEnabled ? 'padding-left: 6px;' : '')}
    }
  }
  .show-on-mobile-qv {
    display: none !important;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex !important;
    }
    ${(props) => (props.isQuickView ? ' display: flex !important;' : '')}
  }
  .show-on-mobile {
    display: none !important;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block !important;
    }
  }
  .show-on-desktop {
    display: block;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none !important;
    }
    ${(props) => (props.isQuickView && props.fromBagPage ? ' display: block !important;' : '')}
    ${(props) => (props.isQuickView && !props.fromBagPage ? ' display: none !important;' : '')}
  }
  .price-rating-section {
    display: flex;
    flex: 1;
    justify-content: space-between;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    ${(props) => props.isNewPJPPDPRedesignEnabled && `flex-direction:column-reverse;`}
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
      ${(props) => (props.isNewPDPEnabled ? 'margin-top: 0px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.isNewPDPEnabled ? 'margin-top:0' : '')}
    }
  }

  .store-spl-rating-cls {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 12px;
    }
  }

  .store-spl-price-cls {
    margin-top: 8px;
    margin-bottom: 12px;
    justify-content: flex-start;
    gap: 18px;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      gap: 10px;
    }
  }

  .store-spl-price-section {
    gap: 18px;
    display: flex;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      gap: 10px;
    }
  }

  .price-afterpay-section {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
      ${(props) => (props.isNewPDPEnabled ? 'margin-top:0px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.isNewPDPEnabled ? 'margin-top:0px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-direction: row;
    }
  }
  .price-section-left {
    ${(props) => props.isNewPJPPDPRedesignEnabled && `padding-top:3px;`}
  }
  .rating-section-right {
    flex-shrink: 0;
    margin-right: 12px;
    ${(props) =>
      props.isNewPJPPDPRedesignEnabled &&
      `margin-top:${props.theme.spacing.ELEM_SPACING.SM};margin-bottom:${props.theme.spacing.ELEM_SPACING.LRG};`}
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-right: 14px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: 0px;
    }
  }
  .price-container.quick-view-drawer-redesign {
    display: ${(props) => (props.isQuickView ? 'flex' : 'block')};
    ${(props) => (props.isQuickView ? 'gap: 10px' : '')};
    ${(props) => (props.isNewPDPEnabled ? 'display: flex; align-items: center;' : '')}
    ${(props) =>
      props.isStoreSpecialsPriceOn && props.storeSpecialPriceFlag ? `align-items:center;` : ''}
  }

  .store-spl-price-cls .badge {
    text-wrap: nowrap;
  }

  .loyalty-text-container {
    color: ${(props) => props.theme.colors.BLACK};
    span {
      color: ${(props) =>
        props.isPlcc
          ? props.theme.colorPalette.userTheme.plcc
          : props.theme.colorPalette.userTheme.mpr};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.isNewPDPEnabled ? `font-size: ${props.theme.typography.fontSizes.fs12};` : ''}
    }
  }
  .afterPay-msg-wrapper {
    position: absolute;
    left: 0;
    ${(props) => (props.isNewQVEnabled && props.fromPickUp ? 'margin-top: 5px;' : '')}
  }
  .newafterPay {
    padding: 5px 0;
  }
  .afterpay-section-right {
    & .newafterPay {
      padding: 0px;
    }
  }
  .fbt-price {
    display: inline-block;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
  .fbt-price-original {
    display: inline-block;
  }

  .pdp-redesign-price-component {
    display: flex;
    column-gap: 8px;
    align-items: center;
  }

  .showStoreSpecialPriceWrapper {
    display: flex;
    gap: 18px;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      gap: 10px;
    }
  }

  .showStoreSpecialPriceSeparator {
    height: 32px;
  }
  .showStoreSpecialPriceSeparatorQV {
    height: 24px;
  }

  .pdp-redesign-price-component-wrapper {
    .actual-price,
    .list-badge-container,
    .original-price,
    .badge {
      margin: 0;
      padding: 0;
      justify-content: center;
      align-items: center;
    }

    .price-iframe {
      vertical-align: middle;
    }

    .actual-price {
      display: flex;
      color: #c8102e;
      font-size: 24px !important;
      font-family: Nunito;
      font-style: normal;
      font-weight: 800 !important;
      line-height: normal;
      white-space: nowrap;
      justify-content: flex-start;

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 28px !important;
      }
    }

    .list-badge-container {
      display: flex;
      flex-direction: column;
    }

    .store-spl-cls {
      flex-direction: row;
      gap: 6px;
    }

    .original-price {
      display: flex;
      color: #9b9b9b;
      font-size: 12px !important;
      font-family: Nunito;
      font-style: normal;
      font-weight: 600 !important;
      line-height: normal;
      text-decoration: line-through;
      white-space: nowrap;
      justify-content: flex-start;
      width: 100%;

      .pre,
      .post {
        line-height: normal;
        color: #9b9b9b;
      }

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 14px !important;
      }
    }

    .badge {
      display: flex;
      color: #c8102e;
      font-size: 12px !important;
      font-family: Nunito;
      font-style: normal;
      font-weight: 800 !important;
      line-height: normal;
      white-space: nowrap;
      justify-content: flex-start;
      width: 100%;

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 14px !important;
      }
    }
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export const VerticalSeperator = styled.span`
  ${(props) => !props.isPriceRange && 'width: 1px; height: 16px; background: #D9D9D9;'}

  @media ${(props) => props.theme.mediaQuery.large} {
    width: 1px;
    height: 24px;
    background: #d9d9d9;
  }
`;

export const PriceAndAfterpayWrapper = styled.div`
  ${(props) =>
    !props.isPriceRange
      ? 'display: flex; flex-direction: row; align-items: center; column-gap: 8px;'
      : 'display: flex; flex-direction: column; align-items: flex-start; row-gap: 2px;'}

  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.showStoreSpecialPrice
        ? 'flex-direction: column; align-items: start; gap: 14px;'
        : 'flex-direction: row; align-items: center; column-gap: 12px;'}
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) =>
      props.showStoreSpecialPrice && 'flex-direction: column; align-items: start; gap: 14px;'}
  }
`;

export default productPriceStyle;
